import { combineReducers } from 'redux';

import { MessageReducer } from '../utils/Message/redux/message.reducer';
import { PersonalInfoReducer } from '../modules/personalInfo/redux/personalInfo.reducers';

const personalFormReducers = combineReducers({
  feedMessage: MessageReducer,
  personalInfo: PersonalInfoReducer,
});

export type PersonalFormState = ReturnType<typeof personalFormReducers>;

export default personalFormReducers;
